import { createActionCreator, createReducer } from 'deox';
import { AppState } from 'types/AppState';

const defaultState: string[] = [];

export const setCurrentTextId = createActionCreator(
  'CURRENT_TEXT_ID/SET',
  resolve => (state: string[]) => resolve(state)
);

export const addCurrentTextId = createActionCreator(
  'CURRENT_TEXT_ID/ADD',
  resolve => (state: string) => resolve(state)
);

export const currentTextId = createReducer(defaultState, handle => [
  handle(setCurrentTextId, (_, { payload }) => payload),
  handle(addCurrentTextId, (state, { payload }) => [...state, payload])
]);

export const getCurrentTextId = (state: AppState): string[] => state.currentTextId;
